// extracted by mini-css-extract-plugin
module.exports = {"title":"e_Nf","container":"e_Of","right":"e_Pf","image":"e_Qf","scoreLine":"e_Rf","scoreRing":"e_Sf","badge":"e_Tf","badgeImage":"e_Uf","badgeRing":"e_Vf","large":"e_Wf"};